import axios from "axios";
import { useContext, useState, useEffect } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import { FiArrowLeft, FiUpload } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/seller/subscreens/editstore/EditStore.css";
import AppContext from "../../../../contexts/AppContext";
import SellerMasterLayout from "../../../../layouts/seller/SellerMasterLayout";
import { useTheme } from "../../../../contexts/ThemeContext";
const EditStore = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles, validateForm , sellerAuthToken} = useContext(AppContext);
  const [storeName, setStoreName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [kycDocumentType, setKycDocumentType] = useState("");
  const [kycDocument, setKycDocument] = useState(null);
  const [shopImage, setShopImage] = useState(null);
  const [shopImagePreview, setShopImagePreview] = useState(null);
  const [storeExists, setStoreExists] = useState(false);
  const [kycPreview, setKycPreview] = useState(null);
  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [categories, setCategories] = useState([]);
  const [storeId, setStoreId] = useState(null);
const { isDark } = useTheme();
  const validateStoreForm = () => {
    let newErrors = {};

    newErrors.storeName = validateForm([["Store name", storeName]]);
    newErrors.description = validateForm([["Description", description]]);
    newErrors.businessEmail = validateForm([["Business email", businessEmail]]);
    newErrors.phoneNumber = validateForm([["Phone number", phoneNumber]]);
    newErrors.address = validateForm([["Street address", address]]);
    newErrors.city = validateForm([["City", city]]);
    newErrors.state = validateForm([["State", state]]);
    newErrors.zipCode = validateForm([["Zip code", zipCode]]);
    newErrors.shopImage = validateForm([
      ["Shop image", storeExists ? "existing-image" : shopImage],
    ]);
    newErrors.kycDocument = validateForm([
      ["KYC document", storeExists ? "existing-document" : kycDocument],
    ]);

    setErrors(newErrors);

    if (
      newErrors.storeName ||
      newErrors.description ||
      newErrors.businessEmail ||
      newErrors.phoneNumber ||
      newErrors.address ||
      newErrors.city ||
      newErrors.state ||
      newErrors.zipCode ||
      newErrors.shopImage ||
      newErrors.kycDocument
    ) {
      return false;
    }
    return true;
  };

  //////////////////////////create store ////////////////////////
  const createStore = () => {
    // NEW: check required fields; errors show under each field, not an alert
    if (!validateStoreForm()) {
      return;
    }

    const formData = new FormData();

    const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
    formData.append("seller_id", seller?.id);
    formData.append("store_name", storeName);
    formData.append("description", description);
    formData.append("category_id", category);
    formData.append("business_email", businessEmail);
    formData.append("phone", phoneNumber);
    formData.append("business_address", address);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("zip_code", zipCode);
    formData.append("kyc_document", kycDocument);
    formData.append("shop_image", shopImage);

    axios
      .post(`${baseUrl}/seller/store/createstore`, formData, {
        headers: { "Content-Type": "multipart/form-data" ,
          Authorization: `Bearer ${sellerAuthToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setShowSuccess(true);
        navigate("/seller/dashboard");
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const updateStore = () => {
    // NEW: check required fields; errors show under each field, not an alert
    if (!validateStoreForm()) {
      return;
    }

    const formData = new FormData();
    const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
    formData.append("seller_id", seller?.id);
    formData.append("store_name", storeName);
    formData.append("description", description);
    formData.append("category_id", category);
    formData.append("business_email", businessEmail);
    formData.append("phone", phoneNumber);
    formData.append("business_address", address);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("zip_code", zipCode);
    if (shopImage) formData.append("shop_image", shopImage);
    if (kycDocument) formData.append("kyc_document", kycDocument);

    axios
      .post(`${baseUrl}/seller/store/updatestore`, formData, {
        headers: { "Content-Type": "multipart/form-data" ,
          Authorization: `Bearer ${sellerAuthToken}`,
         },
      })
      .then(() => {
        setShowSuccess(true);
      })
      .catch((error) => console.error(error));
  };
const getMyStore = () => {
    const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
    axios
      .post(`${baseUrl}/seller/store/getmystore`, {  // GET → POST
        seller_id: seller?.id,     
      },
       {
          headers: {
            Authorization: `Bearer ${sellerAuthToken}`,
          },
        },
      )
      .then((response) => {
        const store = response.data.store;
        if (response.data.success && store) {
          setStoreExists(!!store.store_name);
          setStoreId(store.id);
          setStoreName(store.store_name || "");
          setDescription(store.description || "");
          setCategory(store.category_id || "");
          setBusinessEmail(store.business_email || "");
          setPhoneNumber(store.phone || "");
          setAddress(store.business_address || "");
          setCity(store.city || "");
          setState(store.state || "");
          setZipCode(store.zip_code || "");
          setShopImagePreview(store.shop_image || null);
          setKycPreview(store.kyc_document || null);
        }
      })
      .catch((error) => console.error(error));
  };

  const handleCancel = () => navigate("/seller/settings");
  useEffect(() => {
    getMyStore();
    // getCategories();
  }, []);
  return (
    <SellerMasterLayout>
     <div className={`compact-edit-store ${isDark ? "dark-mode" : ""}`}>
        <Container className="compact-store-container">
          {/* Back Button */}
          <div className="compact-store-header">
            <Button
              className="compact-back-btn"
              onClick={() => navigate("/seller/settings")}
            >
              <FiArrowLeft size={16} />
              Back to Settings
            </Button>
          </div>

          <Card className="compact-store-card">
            <Card.Body>
              <h1 className="compact-title">
                {storeExists ? "Update Store" : "Create Store"}
              </h1>

              {showSuccess && (
                <Alert variant="success" className="compact-success">
                  Store updated successfully!
                </Alert>
              )}

              <Form className="compact-form">
                {/* Store Name */}
                <Form.Group className="compact-editstore-group">
                  <Form.Label>
                    Store Name{" "}
                    {errors.storeName && (
                      <span style={{ color: "#ff6b3d" }}>*</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="storeName"
                    placeholder="Enter store name"
                    value={storeName}
                    onChange={(event) => setStoreName(event.target.value)}
                    className={errors.storeName ? "is-invalid" : ""}
                  />
                  {errors.storeName && (
                    <span className="compact-error">{errors.storeName}</span>
                  )}
                </Form.Group>

                {/* Description */}
                <Form.Group className="compact-editstore-group">
                  <Form.Label>
                    Description{" "}
                    {errors.description && (
                      <span style={{ color: "#ff6b3d" }}>*</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    placeholder="Describe your store..."
                    value={description}
                    onChange={(event) => setDescription(event.target.value)}
                    rows={3}
                    className={errors.description ? "is-invalid" : ""}
                  />
                  {errors.description && (
                    <span className="compact-error">{errors.description}</span>
                  )}
                </Form.Group>

                {/* Category */}
                {/* <Form.Group className="compact-editstore-group">
                  <Form.Label>Category *</Form.Label>
                  <Form.Select
                    name="category"
                    value={category}
                    onChange={(event) => setCategory(event.target.value)}
                    className={errors.category ? "is-invalid" : ""}
                  >
                    <option value="">Select category</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.category_name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.category && (
                    <span className="compact-error">{errors.category}</span>
                  )}
                </Form.Group> */}

                {/* Business Email */}
                <Form.Group className="compact-editstore-group">
                  <Form.Label>
                    Business Email{" "}
                    {errors.businessEmail && (
                      <span style={{ color: "#ff6b3d" }}>*</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="businessEmail"
                    placeholder="business@example.com"
                    value={businessEmail}
                    onChange={(event) => setBusinessEmail(event.target.value)}
                    className={errors.businessEmail ? "is-invalid" : ""}
                  />
                  {errors.businessEmail && (
                    <span className="compact-error">
                      {errors.businessEmail}
                    </span>
                  )}
                </Form.Group>

                {/* Phone */}
                <Form.Group className="compact-editstore-group">
                  <Form.Label>
                    Phone Number{" "}
                    {errors.phoneNumber && (
                      <span style={{ color: "#ff6b3d" }}>*</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    name="phoneNumber"
                    placeholder="+92 300 1234567"
                    value={phoneNumber}
                    onChange={(event) => setPhoneNumber(event.target.value)}
                    className={errors.phoneNumber ? "is-invalid" : ""}
                  />
                  {errors.phoneNumber && (
                    <span className="compact-error">{errors.phoneNumber}</span>
                  )}
                </Form.Group>

                {/* Address */}
                <Form.Group className="compact-editstore-group">
                  <Form.Label>
                    Street Address{" "}
                    {errors.address && (
                      <span style={{ color: "#ff6b3d" }}>*</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    placeholder="123 Main Street"
                    value={address}
                    onChange={(event) => setAddress(event.target.value)}
                    className={errors.address ? "is-invalid" : ""}
                  />
                  {errors.address && (
                    <span className="compact-error">{errors.address}</span>
                  )}
                </Form.Group>

                {/* City, State, Zip */}
                <Row className="compact-grid g-2">
                  <Col>
                    <Form.Group className="compact-editstore-group">
                      <Form.Label>
                        City{" "}
                        {errors.city && (
                          <span style={{ color: "#ff6b3d" }}>*</span>
                        )}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        placeholder="City"
                        value={city}
                        onChange={(event) => setCity(event.target.value)}
                        className={errors.city ? "is-invalid" : ""}
                      />
                      {errors.city && (
                        <span className="compact-error">{errors.city}</span>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="compact-editstore-group">
                      <Form.Label>
                        State{" "}
                        {errors.state && (
                          <span style={{ color: "#ff6b3d" }}>*</span>
                        )}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="state"
                        placeholder="e.g., Punjab, Sindh"
                        value={state}
                        onChange={(event) => setState(event.target.value)}
                        className={errors.state ? "is-invalid" : ""}
                      />
                      {errors.state && (
                        <span className="compact-error">{errors.state}</span>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="compact-editstore-group">
                      <Form.Label>
                        Zip Code{" "}
                        {errors.zipCode && (
                          <span style={{ color: "#ff6b3d" }}>*</span>
                        )}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="zipCode"
                        placeholder="12345"
                        value={zipCode}
                        onChange={(event) => setZipCode(event.target.value)}
                        className={errors.zipCode ? "is-invalid" : ""}
                      />
                      {errors.zipCode && (
                        <span className="compact-error">{errors.zipCode}</span>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* Shop Image Upload */}
                <Form.Group className="compact-editstore-group">
                  <Form.Label>
                    Shop Image{" "}
                    {errors.shopImage && (
                      <span style={{ color: "#ff6b3d" }}>*</span>
                    )}
                  </Form.Label>
                  {/* Shop Image */}
                  <div className="compact-file-upload">
                    <label
                      htmlFor="shop-image-file"
                      className="compact-file-label"
                    >
                      <FiUpload size={14} style={{ marginRight: "6px" }} />
                      {shopImagePreview
                        ? shopImagePreview
                        : "Choose shop image..."}
                    </label>
                    <input
                      id="shop-image-file"
                      type="file"
                      accept="image/*"
                      onChange={(event) => {
                        setShopImage(event.target.files[0]);
                        setShopImagePreview(event.target.files[0].name);
                      }}
                      className="compact-file-input"
                    />
                    {/* Existing image preview */}
                    {shopImagePreview && !shopImage && (
                      <img
                        src={`${baseUrlForFiles}/${shopImagePreview}`}
                        alt="Shop"
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                          marginTop: "8px",
                          borderRadius: "6px",
                        }}
                      />
                    )}
                  </div>
                  {errors.shopImage && (
                    <span className="compact-error">{errors.shopImage}</span>
                  )}
                </Form.Group>

                {/* KYC Documents Info */}
                <Form.Group className="compact-editstore-group">
                  <Form.Label>KYC Documents</Form.Label>
                  <h3 className="kyc-text-heading">
                    Please submit your required KYC documents through the PDF
                    form:
                  </h3>
                  <ul className="kyc-document-list">
                    <li>National ID Card (CNIC/Passport)</li>
                  </ul>
                </Form.Group>

                {/* KYC Upload */}
                <Form.Group className="compact-editstore-group">
                  <Form.Label>
                    Upload Document{" "}
                    {errors.kycDocument && (
                      <span style={{ color: "#ff6b3d" }}>*</span>
                    )}
                  </Form.Label>
                  <div className="compact-file-upload">
                    <label htmlFor="kyc-file" className="compact-file-label">
                      <FiUpload size={14} style={{ marginRight: "6px" }} />
                      {kycPreview ? kycPreview : "Choose file..."}
                    </label>
                    <input
                      id="kyc-file"
                      type="file"
                      accept="image/*,.pdf"
                      onChange={(event) => {
                        setKycDocument(event.target.files[0]);
                        setKycPreview(event.target.files[0].name);
                      }}
                      className="compact-file-input"
                    />
                  </div>
                  {errors.kycDocument && (
                    <span className="compact-error">{errors.kycDocument}</span>
                  )}
                </Form.Group>

                {/* Action Buttons */}
                <div className="compact-actions">
                  <Button
                    type="button"
                    onClick={handleCancel}
                    className="compact-cancel"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    onClick={() => {
                      storeExists ? updateStore() : createStore();
                    }}
                    className="compact-submit"
                  >
                    {storeExists ? "Update Store" : "Save Changes"}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </SellerMasterLayout>
  );
};

export default EditStore;